import { cacheSessionInfo, destroySessionInfo } from 'util/server/session'
import { getProfile } from './profile'
import { updateMarketingCommOptIn } from 'util/server/mainApi'
import { formatPhone } from 'util/format'
import * as mainApi from 'util/server/mainApi'

function identifyFullStory(profileId) {
  if (window.FS) {
    window.FS.identify(profileId)
  }
}

export function signUp(details) {
  return (dispatch) => {
    return mainApi.createUser(details).then((resp) => {
      const data = { ...resp.data }
      updateMarketingCommOptIn(data.user.profile_id, details.marketing_comm_opt_in)
      delete data.user
      cacheSessionInfo(data)
      dispatch(getProfile())
    })
  }
}

function handleSignInData(data) {
  return (dispatch) => {
    cacheSessionInfo(data)
    return dispatch(getProfile()).then(() => {
      dispatch({ type: 'CLEAR_MFA' })
    })
  }
}

function mfaError(error, defaultMessage, clear) {
  return (dispatch) => {
    let message = defaultMessage
    if (error.response && error.response.data && error.response.data.errors) {
      const { errors } = error.response.data
      if (errors.includes('mfa.too_many_sends')) {
        clear = true
        message = "You've attempted to send this code too many times. Please reach out to Support for assistance."
      } else if (errors.includes('mfa.code_expired')) {
        clear = true
        message = 'Sign in expired. Please log in again.'
      } else if (errors.includes('mfa.invalid_method')) {
        clear = true
        message = 'The requested method for verification code is invalid.'
      } else if (errors.includes('mfa.incorrect_code')) {
        clear = false
        message = 'Invalid code. Try again.'
      }
    }
    dispatch({ type: 'PUSH_FLASH', flash: { id: 'mfa', type: 'error', message } })
    if (clear) {
      dispatch({ type: 'CLEAR_MFA' })
    }
  }
}

export function verifyMFA(mfa_guid, mfa_code) {
  return (dispatch) => {
    return mainApi
      .updateMFACode(mfa_guid, mfa_code)
      .then((resp) => {
        return dispatch(handleSignInData(resp.data))
      })
      .catch((resp) => {
        return dispatch(mfaError(resp, 'Something went wrong. Please check your connection and try again.', false))
      })
  }
}

export function sendMFA(mfa_guid, mfa_method = 'sms') {
  return (dispatch) => {
    return mainApi
      .updateMFAMethod(mfa_guid, mfa_method)
      .then((resp) => {
        let { sent_to } = resp.data
        if (mfa_method === 'sms') {
          sent_to = formatPhone(sent_to)
        }
        dispatch({
          type: 'PUSH_FLASH',
          flash: {
            id: 'mfa',
            type: 'success',
            messageKey: 'dweb_phone_verification_text_message_sent_to',
            messageParams: { phoneNumber: sent_to },
          },
        })
        dispatch({ type: 'SET_MFA', guid: mfa_guid, method: mfa_method, sent_to, sent_on: new Date().toISOString() })
      })
      .catch((error) => {
        return dispatch(mfaError(error, 'Could not send verification code.', true))
      })
  }
}

export function signIn(credentials) {
  return (dispatch) => {
    return mainApi
      .createUserSession(credentials)
      .then((resp) => {
        if (resp.data.mfa_required && resp.data.mfa_guid) {
          return dispatch(sendMFA(resp.data.mfa_guid))
        } else {
          return dispatch(handleSignInData(resp.data))
        }
      })
      .catch((e) => {
        if (e && e.response && e.response.status === 409) {
          dispatch({
            type: 'PUSH_FLASH',
            flash: {
              type: 'error',
              messageKey: 'dweb_flash_facebook_signup_no_longer_supported',
            },
          })
        } else throw e
      })
  }
}

export function signInWithToken(token, ephemeral) {
  return async (dispatch) => {
    const resp = await mainApi.createUserSessionWithToken(token)
    cacheSessionInfo(resp.data, ephemeral)
    return dispatch(getProfile())
  }
}

export function forgotPassword(email, path) {
  return () => {
    return mainApi.updatePasswordReset(email, path)
  }
}

export function resetPassword(data) {
  return () => {
    return mainApi.updatePassword(data)
  }
}

export function signOut({ message } = {}) {
  return (dispatch) => {
    destroySessionInfo(message)
    identifyFullStory(false)
    dispatch({ type: 'SIGN_OUT' })
    if (message) {
      setTimeout(() => {
        dispatch({ type: 'PUSH_FLASH', flash: { type: 'alert', message } })
      }, 1000)
    }
  }
}
